export const environment = {
  production: false,
  api_base_url: "https://st-crm-api.ucdevelopments.com/api/",
  api_raw_base_url: "https://st-crm-api.ucdevelopments.com/",
  base_url: "https://st-crm.ucdevelopments.com",
  baseHREF: "/",
  firebase: {
    apiKey: "AIzaSyDl0UnkJ2QjsfDMVLluJgGCTJGVHfzEUyY",
    authDomain: "ucdevelopments-74a3e.firebaseapp.com",
    projectId: "ucdevelopments-74a3e",
    storageBucket: "ucdevelopments-74a3e.firebasestorage.app",
    messagingSenderId: "263100086311",
    appId: "1:263100086311:web:ada9900b2671ef1df03602",
    vapidkey:
      "BKkfN72Qv6KSS0di9l6qUxA31c1nPR1UW1Mt6OyRkodym8gUc5KnYKBr0tV8EuoVSezv9DOkJ1p9HhVoVmI5pas",
  },
};

// /home/admin/web/staging2.fabrica-dev.com/ssh-ali

//scp -i /home/admin/web/staging2.fabrica-dev.com/ssh-ali/Staging.pem -r * ubuntu@3.138.111.226:/var/www/html/castle-backend/public/uploads



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts